import React, { useEffect, useRef } from 'react';
import { Button, Spinner } from 'components';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from 'analytics';
import { ANALYTICS_EVENTS } from 'analytics/events';
import { useOpenedPatient } from 'hooks/useOpenedPatient';

export interface AutomaticInputProps {
  enabled: boolean;
  onSubmit: (patient: { medatixxId: string }) => void;
  onSwitchToManual: (errorMsg?: string) => void;
}

export const AutomaticInput: React.FC<AutomaticInputProps> = ({
  enabled,
  onSubmit,
  onSwitchToManual,
}) => {
  const { t } = useTranslation();
  const { trackEvent } = useAnalytics();
  const { data: openedPatientId, isFetched: hasAskedFacade } = useOpenedPatient({ enabled });
  const facadeDecidedRef = useRef(false);

  useEffect(() => {
    facadeDecidedRef.current = false;
  }, [enabled]);

  useEffect(() => {
    if (!enabled || !hasAskedFacade || facadeDecidedRef.current) {
      return;
    }
    facadeDecidedRef.current = true;
    if (openedPatientId) {
      onSubmit({ medatixxId: openedPatientId });
    } else {
      onSwitchToManual();
    }
  }, [enabled, hasAskedFacade, openedPatientId, onSubmit, onSwitchToManual]);

  return (
    <div className="flex flex-col items-center justify-center py-8 space-y-4">
      <div className="flex items-center justify-center gap-2">
        <Spinner size="xs" />
        <p className="text-base font-medium text-center">
          {t('home.anamnesisLookupDialog.determiningPatient')}
        </p>
      </div>
      <Button
        fullWidth
        data-ph-no-autocapture
        onClick={() => {
          trackEvent(ANALYTICS_EVENTS.HOME_SELECT_ENTER_PATIENT_ID);
          onSwitchToManual();
        }}
      >
        {t('home.anamnesisLookupDialog.enterPatientIdManually')}
      </Button>
    </div>
  );
};
